export const CLIENT_ROUTE_CLIENT_GROUP_LIST = "client.clientGroup.list";
